import Icon from "./IconBase.js";
const UserGroupActiveIcon = (props) => {
  return (
    <Icon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      style={{ borderColor: "white" }}
      {...props}
    >
      <svg
        width="21"
        height="18"
        viewBox="0 0 21 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 18L14.7 16.5C14.5 16.4167 14.3127 16.3293 14.138 16.238C13.9633 16.1467 13.784 16.034 13.6 15.9L12.15 16.35L11.15 14.65L12.3 13.65C12.2667 13.45 12.25 13.2333 12.25 13C12.25 12.7667 12.2667 12.55 12.3 12.35L11.15 11.35L12.15 9.65L13.6 10.1C13.7833 9.96667 13.9627 9.85433 14.138 9.763C14.3133 9.67167 14.5007 9.584 14.7 9.5L15 8H17L17.3 9.5C17.5 9.58333 17.6877 9.671 17.863 9.763C18.0383 9.855 18.2173 9.96733 18.4 10.1L19.85 9.65L20.85 11.35L19.7 12.35C19.7333 12.55 19.75 12.7667 19.75 13C19.75 13.2333 19.7333 13.45 19.7 13.65L20.85 14.65L19.85 16.35L18.4 15.9C18.2167 16.0333 18.0377 16.146 17.863 16.238C17.6883 16.33 17.5007 16.4173 17.3 16.5L17 18H15ZM16 15C16.55 15 17.021 14.8043 17.413 14.413C17.805 14.0217 18.0007 13.5507 18 13C18 12.45 17.8043 11.9793 17.413 11.588C17.0217 11.1967 16.5507 11.0007 16 11C15.45 11 14.9793 11.196 14.588 11.588C14.1967 11.98 14.0007 12.4507 14 13C14 13.55 14.196 14.021 14.588 14.413C14.98 14.805 15.4507 15.0007 16 15ZM2 14V2V6.3V6V14ZM2 16C1.45 16 0.979333 15.8043 0.588 15.413C0.196667 15.0217 0.000666667 14.5507 0 14V2C0 1.45 0.196 0.979333 0.588 0.588C0.98 0.196666 1.45067 0.000666667 2 0H8L10 2H18C18.55 2 19.021 2.196 19.413 2.588C19.805 2.98 20.0007 3.45067 20 4V7.275C19.7 7.05833 19.3833 6.871 19.05 6.713C18.7167 6.555 18.3667 6.41733 18 6.3V4H9.175L7.175 2H2V14H9.075C9.125 14.35 9.20433 14.6917 9.313 15.025C9.42167 15.3583 9.55067 15.6833 9.7 16H2Z"
          fill="white"
        />
      </svg>
    </Icon>
  );
};
export default UserGroupActiveIcon;
